<template>
  <div id="lucky-winner-campaign-list">
    <b-card no-body class="p-2 container-card mb-1">
      <b-row>
        <b-col cols="12">
          <div>
            <div class="d-flex justify-content-end mb-1">
              <add-button
                :btn-label="'Campaign'"
                @click.native="$router.push('/lucky-winner/campaign/create')"
              />
              <!-- hold -->
              <!-- <export-button class="ml-2" @onExport="onOpenExportModal" /> -->
            </div>
            <div class="d-flex flex-wrap justify-content-end">
              <div class="mr-1 ml-1 mb-1">
                <v-select
                  id="campaign-type-status"
                  class="v-select-filter bg-document-list bg-dropdown"
                  :class="status ? 'v-select-filter-selected' : null"
                  placeholder="Status"
                  :options="statusOption"
                  @input="(option) => onSelectFilter('status', option)"
                />
              </div>

              <div class="search-container mb-1">
                <search :on-search-input="onSetValueSearch" />
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="12" class="mb-1">
          <overlay-loading :loading="loading.tableData">
            <template #content>
              <b-table
                :fields="fields"
                :items="campaignListTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                class="default-static-table"
              >
                <template #head(seq)="data">
                  <div class="text-center">
                    {{ data.label }}
                  </div>
                </template>
                <template #cell(status)="data">
                  <b-form-checkbox
                    field-value="true"
                    class="custom-control-success custom-toggle"
                    name="check-button"
                    switch
                    :checked="data.item.status == 1 ? true : false"
                    @change="onToggleStatus($event, data.item)"
                  >
                    <span class="switch-icon-left toggle-text">{{
                      "Active"
                    }}</span>
                    <span class="switch-icon-right toggle-text">{{
                      "Inactive"
                    }}</span>
                  </b-form-checkbox>
                </template>
                <template #cell(actions)="data">
                  <div class="cursor-pointer">
                    <div class="d-flex justify-content-center">
                      <b-button
                        v-b-tooltip.hover
                        title="Edit"
                        variant="secondary"
                        class="default-btn-action mr-2"
                        @click="
                          $router.push(
                            '/lucky-winner/campaign/info/' + data.item.seq
                          )
                        "
                      >
                        <edit-icon
                          class="default-btn-action-svg iconEdit-btn"
                        />
                      </b-button>
                      <b-button
                        v-b-tooltip.hover
                        title="Detail"
                        variant="secondary"
                        class="default-btn-action mr-4 iconSvg-btn"
                        @click="
                          $router.push(
                            `/lucky-winner/campaign/${data.item.seq}/round/list`
                          )
                        "
                      >
                        <detail-icon
                          class="default-btn-action-svg width-size h-auto"
                        />
                      </b-button>
                    </div>
                  </div>
                </template>
                <template #empty>
                  <card-no-item :text-no-img="'Item Not Found'" />
                </template>
              </b-table>
            </template>
          </overlay-loading>
        </b-col>
        <b-col cols="12">
          <pagination-with-reorder
            entity-editable
            :pagination="pagination"
            @entityChange="onFilterEntity"
            @pageChange="onPageChange"
          />
        </b-col>
      </b-row>
    </b-card>
    <!-- hold -->
    <!-- <history-report-modal
      v-if="modalPopup.report"
      @onCloseModal="closeReportModal"
      :moduleTypeKey="defaultReportFilterType.category"
      :moduleKey="defaultReportCategory.lucky_winner"
    /> -->
  </div>
</template>

<script>
import {
  BCol,
  BCard,
  BTable,
  BFormCheckbox,
  BRow,
  BSpinner,
} from "bootstrap-vue";
import EditIcon from "@/@core/components/svg/common/Edit.vue";
import DetailIcon from "@/@core/components/svg/common/IconDetail2.vue";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";
import Search from "@/views/components/search/Search.vue";
import vSelect from "vue-select";

import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";
import useCampaignList from "./hooks/useCampaignList";
// import ExportButton from "@/views/components/button/ExportButton.vue";
import {
  defaultReportFilterType,
  defaultReportCategory,
} from "@/configs/dynamic-config/dynamic-report";
// import HistoryReportModal from "@/views/pages/report/history-report/HistoryReportModal.vue";

export default {
  components: {
    BCol,
    BCard,
    BTable,
    BFormCheckbox,
    BRow,
    BSpinner,
    CardNoItem,
    Search,
    vSelect,
    PaginationWithReorder,
    EditIcon,
    DetailIcon,
  },

  setup() {
    const {
      fields,
      loading,
      statusOption,
      status,
      campaignListTable,
      pagination,
      campaignSelect,
      onPageChange,
      onFilterEntity,
      onSelectFilter,
      onSetValueSearch,
      onToggleStatus,
      modalPopup,
      onOpenExportModal,
      closeReportModal,
    } = useCampaignList();

    return {
      fields,
      loading,
      statusOption,
      status,
      campaignListTable,
      pagination,
      campaignSelect,
      onPageChange,
      onFilterEntity,
      onSelectFilter,
      onSetValueSearch,
      onToggleStatus,
      defaultReportFilterType,
      defaultReportCategory,
      modalPopup,
      onOpenExportModal,
      closeReportModal,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/default-static-table.css";
@import "~@/assets/css/override-styles/v-select.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
@import "~@/assets/css/override-styles/status.css";

.width-size {
  width: 1.6rem;
}

.btn-action,
.btn-action:active {
  border: none;
  background: transparent !important;
  padding: 0;
}

.btn-action-svg {
  width: 20px;
  height: 20px;
  transition: transform 0.3s;
}

.btn-action-svg.active {
  transform: rotate(180deg);
}

.btn-group-action-svg {
  width: 20px;
  height: 20px;
  transition: transform 0.3s;
}

.btn-group-action-svg.active {
  transform: rotate(180deg);
}
</style>
